<template>
  <div>
    <v-container class="text-center">
      <v-list-item-avatar size="100">
        <img :src="displayProfile()" alt="" />
      </v-list-item-avatar>
    </v-container>
    <v-list>
      <v-list-item link class="text-center">
        <v-list-item-title v-if="user" style="font-size: 18px">
          {{ user.name }} {{ user.surname }}<br />
          <small>
            {{ user.department_name }}<br />
            {{ user.role_name }} </small
          ><br />
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import RESOURCES from '@/global/resources'
import { mapGetters, mapState } from 'vuex'
import * as api from '@/http'
import WomanPicture from '@/assets/images/user.png'

export default {
  name: 'AvatarUser',
  data: function () {
    return {
      drawer: null,
      picture: 28,
      profile_image_src: '',
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('utils', ['GET_employeesDepartments', 'GET_employeesFunctions']),
  },
  watch: {},
  mounted: function () {
    this.profile_image_src = RESOURCES.ASSETS_PROFILE_IMAGES() + this.user.profile_image
  },
  methods: {
    displayProfile() {
      return WomanPicture
    },
  },
}
</script>
